<template>
    <a-modal
            :width="'60%'"
            v-model="updateOrg"
            :title="$t('device.modifyOrg')"
            :maskClosable="maskClosable"
            :confirmLoading="confirmLoading"
            @ok="handleOk">

        <div style="padding:20px;">
            <a-card>
                <a-row type="flex" justify="start" :gutter="8">
                    <a-col>
                        <a-upload
                                :action="uploadUrl"
                                :format="['xlsx']"
                                :beforeUpload="beforeUpload"
                                :showUploadList="false"
                                @change="handleChange"
                                :headers="token">
                            <a-button type="primary">
                                <a-icon type="upload" style="padding-right:4px"/>
                                {{$t('global.import')}}
                            </a-button>
                        </a-upload>

                        <a-button style="margin-top:10px;margin-left:10px" @click="downloadExample">
                            <a-icon type="download" style="padding-right:4px"/>
                            {{$t('supervise.downloadTemplate')}}
                        </a-button>
                    </a-col>
                </a-row>

                <div v-for="(item,index) in updateData" :key="index" style="margin-top:15px">
                    <span style="padding-right:10px;">{{item.name}}({{item.data.length}})</span>
                    <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="changeShow(index)">
                        <span v-if="item.isShow">{{$t('device.packUp')}}</span>
                        <span v-else>{{$t('device.expand')}}</span>
                        <a-icon :type="item.isShow ? 'up' : 'down'"/>
                    </a>
                    <a-input-search v-model="item.searchInput" :placeholder="$t('device.IMEISearchPlaceholder')" style="width: 250px;padding-left:20px" @search="onSearch(index)"/>

                    <a-table :columns="columns" :dataSource="item.filteredData" style="margin-top:15px" :pagination="pagination" v-show="item.isShow">
                        <template slot="delete" slot-scope="text, record">
                            <a-popconfirm v-if="item.data.length" :title="$t('global.deleteConfirm')" @confirm="onDelete(record.key,index)">
                                <a href="javascript:;">{{$t('global.delete')}}</a>
                            </a-popconfirm>
                        </template>
                    </a-table>
                </div>

                <a-form style="margin-top:10px">
                    <a-row :gutter="24">
                        <a-col   :md="{span:12}" :lg="{span:8}">
                            <a-form-item :label="$t('global.moveDevice') + `:`" :labelCol="{ span: 10 }" :wrapperCol="{ span: 14 }">
                                <z-org-chooser ref="orgChooser" :option="orgOption"></z-org-chooser>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-card>
        </div>

    </a-modal>
</template>

<script>
    import config from '@/config'
    import {export_json_to_excel} from '@/utils/Export2Excel'
    import ZOrgChooser from '@/components/common/OrgChooser.vue'

    export default {
        name: 'UpdateOrg',
        data() {
            return {
                maskClosable: false,
                confirmLoading: false,
                uploadUrl:config.api.device_update_upload_url,
                token: {},
                updateOrg: false,
                orgOption:{
                    showDirect: false,
                    value: "",
                    id: "updateOrg",
                    isRelative: true
                },
                updateData: [{
                    name: this.$t('device.manuallyChoose'),
                    isShow: false,
                    searchInput: '',
                    filteredData: [],
                    data: []
                }],
                pagination:{pageSize: 5}
            }
        },
        computed: {
            columns() {
                return  [
                    {
                        title: 'IMEI',
                        dataIndex: 'imei',
                        key: 'imei',
                    },
                    {
                        title: 'IMSI',
                        dataIndex: 'imsi',
                        key: 'imsi',
                    },
                    {
                        title: 'ICCID',
                        dataIndex: 'iccid',
                        key: 'iccid',
                    },
                    {
                        title: this.$t('columnCheck.manufacturer'),
                        dataIndex: 'oui',
                        key: 'oui',
                    },{
                        title: this.$t('columnCheck.deviceModel'),
                        dataIndex: 'model',
                        key: 'type',
                    },
                    {
                        title:this.$t('columnCheck.softwareVersion'),
                        dataIndex: 'version',
                        key: 'version',
                    },
                    {
                        title: this.$t('columnCheck.deviceOrg'),
                        dataIndex: 'orgName',
                        key: 'orgName',
                    },
                    {
                        title: this.$t('global.alarmAction'),
                        dataIndex: 'operation',
                        "scopedSlots": {
                            "customRender": "delete"
                        },
                        key: 'operation',
                    }
                ]
            }
        },
        created() {
            this.token = {Authorization:'Bearer ' + this.$store.getters.token}
        },
        components: {
            ZOrgChooser
        },
        methods :{
            beforeUpload (file) {
                if(file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                    this.$message.error(this.$t('global.checkXlsx'))
                    return false
                }
                return true
            },
            handleChange(info) {
                // console.log(info.file)
                if (info.file.status === 'done'){
                    // 文件解析失败
                    if (info.file.response.code != 0) {
                        // console.log('done')
                        this.$notification.error({
                            message: info.file.response.desc
                        })
                        return
                    }
                    if (info.file.response.result.uploadList.length === 0) {
                        this.$notification.open({
                            message: '对不起上传的设备不属于本机构或本机构的下级机构'
                        })
                        return
                    }
                    let updateList = []
                    let uploadList = info.file.response.result.uploadList
                    let timestamp =  info.file.response.result.timestamp
                    let _this = this
                    let repeatNum = 0
                    let updateNum = 0
                    // console.log(uploadList)
                    uploadList.map(function(item){
                        let isRepeat = false
                        _this.updateData.map(function(record){
                            if(record.data.length !== record.data.filter(subItem => subItem.key !== item.oui + "_" + item.imei).length){
                                isRepeat = true
                            }
                            if(isRepeat){
                                repeatNum ++
                            }else{
                                updateNum ++
                                updateList.push({
                                    key: item.oui + "_" + item.imei,
                                    id:item.id,
                                    imei: item.imei,
                                    imsi: item.imsi,
                                    iccid: item.iccid,
                                    orgName:item.orgName,
                                    oui: item.oui,
                                    deviceType: item.type,
                                    version: item.version
                                })
                            }
                        })
                    })
                    if(updateNum != 0){
                        this.updateData.push({
                            name: info.file.name + "_" + timestamp,
                            isShow: false,
                            searchInput: '',
                            filteredData: updateList,
                            data: updateList
                        })
                    }
                    this.$message.success(this.$t('device.deviceExportSuccess', {total: updateNum, repeatNum}))
                }else if(info.file.status === 'error'){
                    // console.log('error')
                    this.$message.error(this.$t('device.deviceExportFailed'))
                }
            },
            handleOk() {
                this.confirmLoading = true
                let updateList = []
                this.updateData.map((list) => {
                    list.data.map((item) => {
                        let device = {}
                        let deviceEx = {}
                        let attrs = {}
                        device.id = item.id
                        if(list.name == this.$t('device.manuallyChoose')){
                            attrs.batchNo = 'manual'
                        }else{
                            attrs.batchNo = list.name
                        }
                        deviceEx.attrs = attrs
                        device.deviceExtension = deviceEx
                        updateList.push(device)
                    })
                })
                if(updateList.length == 0){
                    this.$message.error(this.$t('device.noModifiedDevices'))
                    this.confirmLoading = false
                }else{
                    this.$http.post(config.api.device_update_org_url + "/" + this.orgOption.orgId,updateList).then((response) => {
                        this.confirmLoading = false
                        if(response.code == 0){
                            this.updateOrg = false
                            this.$notification.success({
                                message: this.$t('device.modifiedSuccess')
                            })
                            this.$emit('updateSuccess')
                        }
                    }).catch((err) => {
                        console.log(err)
                        this.confirmLoading = false
                    })
                }
            },
            showUpdateOrgModel(data) {
                this.updateOrg = true
                this.updateData =  [{
                    name: this.$t('device.manuallyChoose'),
                    isShow: false,
                    searchInput: '',
                    filteredData: [],
                    data: []
                }]
                this.updateData[0].data = data
                this.updateData[0].filteredData = data
                if(this.$refs["orgChooser"]){
                    this.$refs["orgChooser"].initOrgTree()
                }
            },
            changeShow(index) {
                this.updateData[index].isShow = !this.updateData[index].isShow
            },
            onSearch(index) {
                this.updateData[index].filteredData = this.updateData[index].data.filter(item => item.key.indexOf(this.updateData[index].searchInput) != -1)
            },
            onDelete(key,index) {
                this.updateData[index].data = this.updateData[index].data.filter(item => item.key !== key)
                this.updateData[index].filteredData = this.updateData[index].filteredData.filter(item => item.key !== key)
                if(index != 0 && this.updateData[index].data.length == 0){
                    this.updateData.splice(index,1)
                }
            },
            downloadExample(){
                let tHeader = [this.$t('columnCheck.manufacturer'),this.$t('columnCheck.serialNumber')];
                let exportData = [['ZX','460041811600012'],['ZX','460041819727291']];
                export_json_to_excel(tHeader, exportData, '设备列表模板');
            }
        }
    }
</script>